import React from "react";
import s from "./HubStructure.module.scss";
import ScaledDiagram from "../ScaledDiagram/ScaledDiagram";

// Interaction of MCTAC and the Digital Transit HUB with regional
// representatives (redrawn from /hub.png)
const partners = [
  { partner: "1", country: "1" },
  { partner: "2", country: "2" },
  null, // "…" placeholder for the partners in between
  { partner: "n", country: "n" },
];

// horizontal centre of column i in the 4-column grid (gap 20px)
const col = (i) => `calc((100% - 60px) / 8 * ${2 * i + 1} + ${20 * i}px)`;

const HubStructure = () => (
  <figure
    className={s.chart}
    aria-label="Interaction of MCTAC and the Digital Transit HUB with regional representatives"
  >
    <ScaledDiagram designWidth={800}>
      <div className={s.top}>
        <div className={`${s.node} ${s.mctac}`}>
          <img src="/Logo MCTAC.png" alt="" className={s.emblem} />
          Middle Corridor Transit Advisory Committee
        </div>
        <div className={`${s.node} ${s.hub}`}>Digital Transit HUB</div>
      </div>

      <div className={s.links} aria-hidden="true">
        <span className={s.mctac_down}></span>
        <span
          className={s.hub_down}
          style={{ left: `calc(${col(3)} - 1px)` }}
        ></span>
        <span
          className={s.contract_bus}
          style={{ left: `calc(${col(0)} - 10px)`, width: `calc(${col(3)} - ${col(0)})` }}
        >
          <em>Contract</em>
        </span>
        <span
          className={s.access_bus}
          style={{ left: `calc(${col(0)} + 10px)`, width: `calc(${col(3)} - ${col(0)})` }}
        >
          <em>Access to HUB</em>
        </span>
        {partners.map((_, i) => (
          <React.Fragment key={i}>
            <span
              className={s.contract_drop}
              style={{ left: `calc(${col(i)} - 11px)` }}
            ></span>
            <span
              className={s.access_drop}
              style={{ left: `calc(${col(i)} + 9px)` }}
            ></span>
          </React.Fragment>
        ))}
      </div>

      <div className={s.partners}>
        {partners.map((p, i) =>
          p ? (
            <div className={`${s.node} ${s.partner}`} key={i}>
              <span>
                Partner X<sup>{p.partner}</sup>
              </span>
              <span className={s.country}>
                Country Y<sup>{p.country}</sup>
              </span>
              <span className={s.tags}>
                <span className={s.tag_contract}>Contract</span>
                <span className={s.tag_access}>Access to HUB</span>
              </span>
            </div>
          ) : (
            <div className={`${s.node} ${s.partner} ${s.ellipsis}`} key={i}>
              …
            </div>
          )
        )}
      </div>

      <figcaption className={s.legend}>
        <span className={s.legend_contract}>Contract</span>
        <span className={s.legend_access}>Access to HUB</span>
      </figcaption>
    </ScaledDiagram>
  </figure>
);

export default HubStructure;
